import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

import { environment } from '@ib-env/environment';
import { AbstractBaseComponent } from '@ib-shared/abstract/abstract-base';
import { CodeInputWrapComponent } from '@ib-shared/modules/code-input-wrap/code-input-wrap.component';
import { INVESTOR_SIGN_UP_STEPS } from 'credebt-shared';
import { takeUntil } from 'rxjs';

import { SIGN_UP_FIELDS } from '../../../enums/sign-up-fields.enum';
import { ISignUpStep } from '../../../interfaces/sign-up-step.intf';
import { SignUpFacadeService } from '../../../services/sign-up-facade.service';
import { SignUpFormHelperService } from '../../../services/sign-up-form-facade.service';

@Component({
  selector: 'ib-sign-up-step-address',
  templateUrl: './sign-up-step-address.component.html',
  styleUrls: ['./sign-up-step-address.component.scss'],
})
export class SignUpStepAddressComponent
  extends AbstractBaseComponent
  implements OnInit
{
  @Input() form: FormGroup;
  public readonly SIGN_UP_FIELDS = SIGN_UP_FIELDS;
  get countryCodeCtrl(): AbstractControl {
    return this.form.get(SIGN_UP_FIELDS.COUNTRY_CODE);
  }
  public sendCodeLoading$ = this.facadeS.selectIsSendCodeLoading();
  public codeExpireAt$ = this.facadeS.selectPhoneCodeExpireAt();
  public config: ISignUpStep;
  public isSentMsgAvailable = true;
  @ViewChild('codeInput') codeInputComp: CodeInputWrapComponent;
  @ViewChild('streetInput') streetInput: ElementRef<HTMLInputElement>;

  constructor(
    public facadeS: SignUpFacadeService,
    public formS: SignUpFormHelperService,
  ) {
    super();
  }

  handleExpireWithUnconfirmedCode(): void {
    this.isSentMsgAvailable = false;
  }

  ngOnInit(): void {
    this.config = this.facadeS.getStepByType(INVESTOR_SIGN_UP_STEPS.ADDRESS);
    this.initSendCodeSuccess();
    this.initFormFields();
    this.facadeS.handleExpireWithUnconfirmedCode$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.codeInputComp.clearCode();
      });
  }

  private initSendCodeSuccess(): void {
    this.facadeS.eventSendCodeToMobileSuccess$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.facadeS.initExpireInUiLabel();
      });
  }

  phoneConfirmed(v: { phoneId: string }): void {
    this.facadeS.setPhoneId(v.phoneId);
    // this.facadeS.setPhoneId('test');
    this.streetInput?.nativeElement?.focus();
  }

  resendCode(): void {
    this.facadeS.sendCodeToPhone().subscribe(() => {
      this.isSentMsgAvailable = true;
    });
  }

  submitFromInput(e): void {
    e.stopPropagation();
    e.preventDefault();
    if (this.form.valid) {
      this.facadeS.setNextStep();
    } else {
      this.form.markAllAsTouched();
    }
  }

  private initFormFields(): void {
    // mock
    if (!environment.production && environment.allowSignUpUseMocks) {
      this.form
        .get(this.SIGN_UP_FIELDS.STREET_AND_NUMBER)
        .setValue('av. Keletska 121');
      this.form.get(this.SIGN_UP_FIELDS.CITY).setValue('Dublin');
      this.form.get(this.SIGN_UP_FIELDS.POSTAL_ZIP_CODE).setValue('12212');
    }
  }
}
